const compare = require('./compare')
const lt = (a, b, loose) => compare(a, b, loose) < 0
module.exports = lt



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/lt.js
// module id = 201
// module chunks = 1